import React from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import GroupIcon from "@mui/icons-material/Group";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { COBRECBarra } from "./COBRECBarra";
import { COBRECCelda } from "./COBRECCelda";
import { useHistory } from "react-router-dom";

export const COBRECDetail = ({ item, icono, graphics, filtrado, permisos }) => {
  const history = useHistory();
  const valor = (prop, valor) => {
    try {
      var result = item.filter((element) => element.estado === prop);
      return result[0][valor];
    } catch (error) {
      return 0;
    }
  };
  return (
    <>
      <tr className="tr-encabezado-cobranza" onClick={() =>
          history.push(
            "/Creditoycobranza/GestionClientes", {
              linea: filtrado,
              cartera: "C",
              permisos
            })
        }>
        <td>{icono}</td>
        <td>
          <COBRECBarra
            recuperado={valor("T", "recuperado")}
            porcentaje={valor("T", "porcentaje")}
            indicador={valor("T", "indicador")}
            objetivo={valor("T", "objetivo")}
            clientes={0}
          />
        </td>
      </tr>
      <tr>
        <td colSpan={2}>
          {graphics !== undefined && graphics !== null && (
            <div className="td-cobranza-detalle">
              <COBRECCelda
                titulo={"Vencida"}
                linea={filtrado}
                cartera={"V"}
                type={"V"}
                data={item.filter(
                  (element) => element.estado === "V" || element.estado === "TV"
                )}
                permisos={permisos}
              />
              <COBRECCelda
                titulo={"Por vencer"}
                linea={filtrado}
                cartera={"P"}
                type={"P"}
                data={item.filter((element) => element.estado === "P" || element.estado === "TP")}
                permisos={permisos}
              />
              {/* <COBRECCelda
                titulo={"Activa"}
                type={"A"}
                data={item.filter((element) => element.estado === "A"|| element.estado === "TA")}
              /> */}
            </div>
          )}
        </td>
      </tr>
    </>
  );
};
